import axios from '@/utils'

// 获取短信验证码
export function getVerifyCode (data) {
    return axios({
        method: 'post',
        url: '/login/getVerifyCode',
        data,
    })
}

//手机号登录
export function phoneLogin (data) {
    return axios({
        method: 'post',
        url: '/login/phoneLogin',
        data,
    })
}